/*
 * Author: Danny Ehlers
 * Date: 3/15/2019
 * This was designed to be used with Azure DevOps. The values can be replaced using JSON variable substitution
 * during the release pipeline on Azure App Services Deployment.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Settings, AdminSettings, HtmlTemplate } from './domain/settings';
import { environment } from '../environments/environment';
import { ICodeLookup } from './domain/ICodeLookup';

@Injectable({
  providedIn: 'root',
})
export class SettingsProviderService {

  private config: Settings;
  baseUrl: string = "";
  private adminSetting: AdminSettings;
  private _dashboardLinks: ICodeLookup[] = [];

  private _htmlTemplates:HtmlTemplate[] =[];

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public loadConfig(): Promise<any> {

    return this.http
      .get('assets/client-config.json').pipe(settings => settings)
      .toPromise()
      .then(settings => {
        let clientConfig = settings as Settings;
        if (clientConfig.useCustomConfig) {
          this.config = settings as Settings;
        } else {
          this.config = environment as Settings;
        }
        sessionStorage.setItem('settings', JSON.stringify(this.config));
      });

  }


  public loadAdminSetting() {
    console.log("Getting admin settings");
    return this.http
      .get<any>(this.baseUrl + 'api/CodeLookup/AdminSetting/')
      .subscribe(result => {
        if (result.isSuccess) {
          this.adminSetting = result.data as AdminSettings;
          console.log(this.adminSetting);
          sessionStorage.setItem('adminSettings', JSON.stringify(this.adminSetting));
        } else {
          console.log(result.message);
        }
      }, error => console.error(error));

  }

  public loadDashboardLinks() {
    console.log("Getting dashboard links");
    return this.http
      .get<any>(this.baseUrl + 'api/CodeLookup/GetCodeLookups/8')
      .subscribe(result => {
          this._dashboardLinks = result as ICodeLookup[];
          console.log(this._dashboardLinks);
          sessionStorage.setItem('dashboardLinks', JSON.stringify(this._dashboardLinks));
      }, error => console.error(error));
  }

  public loadHtmlTemplates() {
    console.log("Getting Html Templates");
    return this.http
      .get<any>(this.baseUrl + 'api/CodeLookup/HtmlTemplates/')
      .subscribe(result => {
        if (result.isSuccess) {
          this._htmlTemplates = result.data as HtmlTemplate[];
          console.log(this._htmlTemplates);
          sessionStorage.setItem('htmlTemplates', JSON.stringify(this._htmlTemplates));
        } else {
          console.log(result.message);
        }
      }, error => console.error(error));

  }

  public getAnnouncements() {
    return this.http.get<any>(this.baseUrl + 'api/CodeLookup/Announcements/');
  }

  public get adminSettings(): AdminSettings {
    if (!this.adminSetting) {
      try {
        var setting = JSON.parse(sessionStorage.adminSettings);
        return setting as AdminSettings;
      } catch (e) {
        return this.adminSetting;
      }
    }
    return this.adminSetting;
  }

  public get dashboardLinks(): ICodeLookup[] {
    if (!this._dashboardLinks) {
      try {
        var links = JSON.parse(sessionStorage.dashboardLinks);
        return links as ICodeLookup[];
      } catch (e) {
        return this._dashboardLinks;
      }
    }
    return this._dashboardLinks;
  }

  public get htmlTemplates(): HtmlTemplate[] {    
    if (!this._htmlTemplates && this._htmlTemplates.length == 0) {
      try {
        var templates = JSON.parse(sessionStorage.htmlTemplates);
        this._htmlTemplates = templates;
      } catch (e) {
        console.error('issue loading html templates');
      }
      return this._htmlTemplates;
    }
    else
    {
      this.loadHtmlTemplates();
    }
    console.log('template ' + JSON.stringify(this._htmlTemplates));
    return this._htmlTemplates;
  }

  public get configuration(): Settings {
    if (!this.config) {
      try {
        var sessionConfig = JSON.parse(sessionStorage.settings);
        return sessionConfig as Settings;
      } catch (e) {
        return this.config;
      }

    }
    return this.config;
  }

  public static get configurationFromSession(): Settings {
    try {
      var sessionConfig = JSON.parse(sessionStorage.settings);
      return sessionConfig as Settings;
    } catch (e) {
      return null;
    }
  }


}
